$(document).ready(function () {
    const carouselImagesProgramme = $(".carouselImagesProgramme").owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        dots: false,
        nav: false,
        loop: true
    });

    const carouselProgrammeModal = $('.carousel-programme-modal').owlCarousel({
        items: 1,
        dots: false,
        loop: true,
        autoplay: true
    });

    $('.owlNext').on('click', function () {
        carouselImagesProgramme.trigger('next.owl.carousel');
        carouselProgrammeModal.trigger('next.owl.carousel');
    });

    $('.owlPrev').on('click', function () {
        carouselImagesProgramme.trigger('prev.owl.carousel');
        carouselProgrammeModal.trigger('prev.owl.carousel');
    });

    // Fonction générique pour calculer la mensualité
    function calculerMensualite(selectClass, prixId, outputId, financementClass) {
        // Vérifier si l'élément existe avant d'ajouter le handler
        console.log($(outputId))

        if ($(selectClass).length === 0) {
            return;
        }

        $(selectClass).change(function () {
            var value = $(this).val().split(";");
            var taux = value[0] / 100;
            var annee = value[1];
            var mensualite = annee * 12;
            var prix = $(prixId).val();
            var total =
                (prix * (taux / 12)) / (1 - Math.pow(1 + taux / 12, -mensualite));
            $(outputId).text(Math.round(total));
            if (financementClass && $(financementClass).length > 0 && $(financementClass).html().length == 0)
                $(financementClass).html(Math.round(total));
        });
    }

    // Anciens selects (compatibilité)
    calculerMensualite(".selectAnnee", "#prix", "#pricePrint", ".financement");
    calculerMensualite(".selectAnnee2", "#prix2", "#pricePrint2", ".financement2");

    // Nouveaux selects pour TVA 5.5% et 20% (Pour habiter)
    calculerMensualite(".selectAnneeHabiterTVA55", "#prixHabiterTVA55", "#pricePrintHabiterTVA55", null);
    calculerMensualite(".selectAnneeHabiterTVA20", "#prixHabiterTVA20", "#pricePrintHabiterTVA20", null);

    // Nouveaux selects pour TVA 10% et 20% (Pour investir)
    calculerMensualite(".selectAnneeInvestirTVA10", "#prixInvestirTVA10", "#pricePrintInvestirTVA10", null);
    calculerMensualite(".selectAnneeInvestirTVA20", "#prixInvestirTVA20", "#pricePrintInvestirTVA20", null);

    $.ajax({
        url: "/api/programme/programmesSimilaires",
        type: "GET",
        dataType: "json",
        data: {
            programmeId: $("#programmeId").val(),
        },
        success: function (data) {
            $("#programmeSimilaires").html(data.html);
        },
        error: function (err) {
            console.log(err);
        },
    });

    // Déclencher les calculs au chargement de la page (seulement si l'élément existe)
    if ($(".selectAnnee").length > 0) $(".selectAnnee").change();
    if ($(".selectAnnee2").length > 0) $(".selectAnnee2").change();
    if ($(".selectAnneeHabiterTVA55").length > 0) $(".selectAnneeHabiterTVA55").change();
    if ($(".selectAnneeHabiterTVA20").length > 0) $(".selectAnneeHabiterTVA20").change();
    if ($(".selectAnneeInvestirTVA10").length > 0) $(".selectAnneeInvestirTVA10").change();
    if ($(".selectAnneeInvestirTVA20").length > 0) $(".selectAnneeInvestirTVA20").change();

    // Calculer le financement initial pour #firstFinancement
    if ($("#firstFinancement").length > 0 && $("#minPrice").length > 0) {
        var minPrice = parseFloat($("#minPrice").val());
        if (minPrice > 0) {
            // Utiliser les valeurs par défaut : taux de 3.5% sur 25 ans
            var taux = 0.035;
            var annee = 25;
            var mensualite = annee * 12;
            var total = (minPrice * (taux / 12)) / (1 - Math.pow(1 + taux / 12, -mensualite));
            $("#firstFinancement").text(Math.round(total));
        }
    }

    const inputsRadio = $('#bienIdeal #pour').find('input[type="radio"]');
    inputsRadio.each(function () {
        const value = $(this).val();
        $(this).on('click', function () {
            if (value == 'habiter') {
                $(".pourHabiterWrapper").removeClass('hidden');
                $(".pourInvestirWrapper").addClass('hidden');
                $("#select-defiscalisation").addClass('hidden');
            } else {
                $(".pourHabiterWrapper").addClass('hidden');
                $(".pourInvestirWrapper").removeClass('hidden');
                $("#select-defiscalisation").removeClass('hidden');
            }
        });
    });

    $('#bienIdeal #pour input:checked').trigger('click');
});